import { AxiosInstance } from "../utils/axios-helper/axios-helper";
import { API_END_POINT } from "../utils/constants/api-end-points";
import { version } from "../config";

export const getWalletData = async (data) => {
  return await AxiosInstance.get(`${version}${API_END_POINT.getWalletData}?HfSession=${data.hfSession}&languageId=${data.languageId}`);
};

export const getRewardsHistory = async () => {
  return await AxiosInstance.get(
    `${version}${API_END_POINT.getRewardsHistory}`
  );
};

export const getAllMyWins = async (data) => {
  return await AxiosInstance.get(`${version}${API_END_POINT.getMyWins}?HfSession=${data.hfSession}&languageId=${data.languageId}`);
};
